export default "__VITE_ASSET__g_XbJgW4__"